<script lang="ts">
	import H from '$lib/html/h/H.svelte';
	import { widget } from '$lib/stores/widget';
	import { getFontTitle } from '$lib/widget/helper/widget';
	import { widgetColors } from '$lib/widget/stores';

	interface Props {
		level?: string;
		className?: string;
		children?: import('svelte').Snippet;
	}

	let { level = '1', className = 'mt-4 mb-8', children }: Props = $props();

	let fontClasses =
		$derived($widgetColors.fontFamily || $widget?.theme.fontFamily
			? getFontTitle()
			: 'font-title font-extralight');
</script>

<H {level} className="{className} text-balance" {fontClasses}>
	{@render children?.()}
</H>
